import apiClient from "../helpers/ApiClient";
import { handleError, authHeader } from "../helpers/ApiClient";

export const kitchenService = {
    getKitchen,
    addKitchen,
    deleteKitchen
}
function getKitchen(){
    return apiClient
        .get("/kitchen_message", {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

async function addKitchen(text) {
    return apiClient
        .post("/kitchen_message", text, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

async function deleteKitchen(kitchenMessageId) {
    return apiClient
        .delete(`/kitchen_message/${kitchenMessageId}`, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}


